import { useEffect, useState } from "react";
import { API_URL } from "../../../config/api";

export default function useMaintenanceStatus(pollMs = 20000) {
  const [status, setStatus] = useState(null); // null finché non arriva la prima risposta
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;

    function load() {
      fetch(`${API_URL}/api/maintenance`)
        .then((res) => res.json())
        .then((json) => !cancelled && setStatus(json))
        .catch(() => !cancelled && setError(true));
    }

    load();
    const interval = setInterval(load, pollMs);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [pollMs]);

  return { status, error };
}
